<template>

    <div class="other-field ">
        <div class="display-flex">
            <div class="label-width">
                <div class="label-icon"><i class="fas fa-language"></i></div>
                <div class="label-text">Translation / Message</div>
            </div>
            <div class="label-field no-bg">
                <div class="what-info">Translation will be published here</div>
                <textarea class="textarea" type="text" :rows="lines" placeholder="Please request translation"
                          v-model="translation.body"
                          :readonly="!isAdmin"></textarea>
            </div>
        </div>
        <div class="other-button text-center" v-if="isAdmin">
            <button class="button is-theme-primary"
                    v-bind:class="{ 'is-loading': isLoading }"
                    v-if="!isTranslated"
                    @click="createNewTranslation">Post</button>
            <button class="button is-theme-primary"
                    v-bind:class="{ 'is-loading': isLoading }"
                    v-if="isTranslated"
                    @click="updateTranslation">Update</button>
        </div>
    </div>
</template>

<script>
    import commentsApi from './../../../../api/apiTranslations.js'
    export default {
        props:['lot'],
        data() {
          return {
              isLoading: false,
              isTranslated: false,
              lines: null,
              translation: {
                  lot_id: this.lot.lot_id,
                  body: null
              }
          }
        },
        methods: {
            createNewTranslation() {
                this.isLoading = true
                commentsApi
                    .placeTranslationRequest(this.translation)
                    .then((response) => {
                        this.translation = response.data
                        this.isTranslated = true
                        this.isLoading = false
                    })
                    .catch(error => console.log(error))
            },
            updateTranslation() {
                this.isLoading = true
                commentsApi
                    .updateTranslationRequest(this.translation)
                    .then((response) => {
                        this.translation = response.data
                        this.isTranslated = true
                        this.isLoading = false
                    })
                    .catch(error => console.log(error))
            }
        },
        computed: {
            isAdmin() {
                if (this.$store.getters.getUserRole === 'Admin') {
                    return true
                }
            },
        },
        created () {
            if(this.lot.translation){
                this.translation = this.lot.translation
                this.isTranslated = true
                this.lines = this.lot.translation.body.split(/\r\n|\r|\n/).length
            }
        }
    }
</script>

<style scoped>
    table {
        font-size: small;
    }
</style>




// WEBPACK FOOTER //
// src/components/Auctions/Lot/Details/TranslationBox.vue